<template>
    <div id="fullpage" class="fullpage-wrapper" >
    <Slider></Slider>
      <ContactMe></ContactMe>
      <Hihighted></Hihighted>
      <HomePageContent></HomePageContent>
      <LastGallery></LastGallery>
      <About></About>
      <Testimonal></Testimonal>
      <Review></Review>
    </div>
</template>

<script>
import Menu from './Menu'
import Slider from './Slider'
import About from './About'
import Testimonal from './Testimonal'
import LastGallery from './LastGallery'
import HomePageContent from './HomePageContent'
import ContactMe from './ContactMe'
import Hihighted from './Hihighted'
import Review from './Review'
export default {
  name: 'Home',
  components: {
    HomePageContent,
    Hihighted,
    ContactMe,
    LastGallery,
    Testimonal,
    Slider,
    Menu,
    Review,
    About},
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue